<template>
  <div class="row mt-4" v-if="tipsters.length > 1">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">Comparativa de tipsters</h6>
              <p class="text-xs opacity-7 mb-0">Rendimiento de cada tipster en el portfolio</p>
            </div>
            <div class="btn-group btn-group-sm" role="group">
              <button
                v-for="o in metricas"
                :key="o.key"
                class="btn btn-sm mb-0"
                :class="metrica === o.key ? 'btn-activo' : 'btn-inactivo'"
                @click="metrica = o.key"
              >{{ o.label }}</button>
            </div>
          </div>

          <div class="comp-list">
            <div
              v-for="(t, i) in tipstersSorted"
              :key="t.tipster_id"
              class="comp-row"
            >
              <div class="comp-nombre">
                <span class="comp-dot" :style="{ background: paleta[i % paleta.length] }"></span>
                {{ t.tipster_nombre }}
              </div>
              <div class="comp-bar-wrap">
                <div
                  class="comp-bar-fill"
                  :style="{ width: barWidth(t) + '%', background: paleta[i % paleta.length] }"
                ></div>
              </div>
              <div class="comp-val">{{ fmtVal(t) }}</div>
              <div class="comp-sub">{{ fmtSub(t) }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PALETA = [
  "#f5a623","#2ee27f","#ff5964","#8e24aa","#00acc1","#3949ab","#7cb342","#fb8c00",
];

export default {
  name: "PanelPublicistaComparativa",
  props: {
    tipsters: { type: Array, default: () => [] },
  },
  data() {
    return {
      metrica: "suscritos",
      paleta: PALETA,
      metricas: [
        { key: "suscritos", label: "Suscritos act." },
        { key: "entradas",  label: "Entradas" },
        { key: "bajas",     label: "Bajas" },
      ],
    };
  },
  computed: {
    tipstersSorted() {
      return [...this.tipsters].sort((a, b) => this.valorDe(b) - this.valorDe(a));
    },
    maxVal() {
      return Math.max(...this.tipsters.map(t => this.valorDe(t)), 1);
    },
  },
  methods: {
    valorDe(t) {
      if (this.metrica === "suscritos") return t.totales.suscritos_actuales || 0;
      if (this.metrica === "entradas")  return t.totales.entradas_total || 0;
      if (this.metrica === "bajas")     return t.totales.salidas_total || 0;
      return 0;
    },
    barWidth(t) {
      const v = this.valorDe(t);
      if (v === 0) return 0;
      return Math.max((v / this.maxVal) * 100, 2);
    },
    fmtVal(t) {
      return this.valorDe(t);
    },
    fmtSub(t) {
      if (this.metrica === "suscritos") return `${t.totales.entradas_total} entradas`;
      if (this.metrica === "entradas")  return `${t.totales.suscritos_actuales} suscritos`;
      if (this.metrica === "bajas")     return `${t.totales.suscritos_actuales} suscritos actuales`;
      return "";
    },
  },
};
</script>

<style scoped>
.btn-inactivo {
  background: var(--q-card); color: var(--q-muted);
  border: 1px solid var(--q-border); border-radius: 8px !important;
  font-size: 11px; font-weight: 600; padding: 4px 10px; transition: .15s;
}
.btn-inactivo:hover { background: var(--q-hover); color: var(--q-gold); }
.btn-activo {
  background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover));
  color: var(--q-gold-on) !important; border:1px solid transparent !important;
  border-radius:8px !important; font-size:11px; font-weight:700; padding:4px 10px;
}

.comp-list { display: flex; flex-direction: column; gap: 12px; }

.comp-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.comp-dot {
  display: inline-block;
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.comp-nombre {
  min-width: 150px;
  max-width: 200px;
  font-size: 12px;
  font-weight: 700;
  color: var(--q-text);
  display: flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comp-bar-wrap {
  flex: 1;
  background: var(--q-hover);
  border-radius: 8px;
  height: 20px;
  overflow: hidden;
}

.comp-bar-fill {
  height: 100%;
  border-radius: 8px;
  opacity: 0.85;
  transition: width .4s ease;
}

.comp-val {
  min-width: 90px;
  text-align: right;
  font-size: 13px;
  font-weight: 800;
  color: var(--q-text);
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
}

.comp-sub {
  min-width: 90px;
  text-align: right;
  font-size: 11px;
  color: var(--q-muted);
  font-family: var(--q-font-mono);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 480px) {
  .comp-nombre { min-width: 0; max-width: 100%; flex: 0 0 100%; white-space: normal; }
  .comp-bar-wrap { flex: 1 1 60%; }
  .comp-sub { display: none; }
}
</style>
